import { useOfflineSync } from "@/hooks/useOfflineSync";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Wifi, WifiOff, RefreshCw, AlertCircle } from "lucide-react";

export const OfflineIndicator = () => {
  const { isOnline, pendingCount, isSyncing, syncOfflineData } = useOfflineSync();

  // If online and no changes are pending, don't show anything
  if (isOnline && pendingCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-lg px-4 animate-in fade-in slide-in-from-bottom-5 duration-300">
      {!isOnline ? (
        // Offline Warning Banner
        <div className="rounded-2xl border border-amber-500/20 bg-slate-950/80 p-4 shadow-[0_8px_32px_rgba(245,158,11,0.15)] backdrop-blur-xl text-white flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400">
              <WifiOff className="h-5 w-5 animate-pulse" />
            </div>
            <div>
              <h4 className="text-sm font-bold text-slate-100 flex items-center gap-1.5">
                Você está offline
              </h4>
              <p className="text-xs text-slate-400 leading-normal mt-0.5">
                Você está offline. As alterações serão salvas localmente.
              </p>
            </div>
          </div>
          {pendingCount > 0 && (
            <Badge variant="secondary" className="bg-amber-500/10 hover:bg-amber-500/20 text-amber-300 text-[10px] font-semibold border border-amber-500/20 py-1 shrink-0">
              {pendingCount} {pendingCount === 1 ? "pendente" : "pendentes"}
            </Badge>
          )}
        </div>
      ) : (
        // Online Pending Changes / Sync Banner
        <div className="rounded-2xl border border-emerald-500/20 bg-slate-950/80 p-4 shadow-[0_8px_32px_rgba(16,185,129,0.15)] backdrop-blur-xl text-white flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-400">
              <Wifi className="h-5 w-5" />
            </div>
            <div>
              <h4 className="text-sm font-bold text-slate-100">
                Conexão Restabelecida
              </h4>
              <p className="text-xs text-slate-400 leading-normal mt-0.5">
                Sua conexão voltou. Pronto para sincronizar as alterações locais.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Badge variant="secondary" className="bg-emerald-500/10 text-emerald-300 text-[10px] font-semibold border border-emerald-500/20 py-1">
              {pendingCount} {pendingCount === 1 ? "pendente" : "pendentes"}
            </Badge>
            <Button
              size="sm"
              onClick={syncOfflineData}
              disabled={isSyncing}
              className="h-8 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-xs font-bold text-white px-3 transition-colors"
            >
              <RefreshCw className={`h-3.5 w-3.5 mr-1.5 ${isSyncing ? 'animate-spin' : ''}`} />
              {isSyncing ? "Sincronizando..." : "Sincronizar"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;